export default "/images/45ad6886bb8f6ea71dceecbd83848f8f.avif";